import React from "react";
import { Select } from "./select";
import { Warehouse } from "../../types/warehouse";

interface DeliveryLocationProps {
  warehouses: Warehouse[];
  value?: Warehouse | null;
  onSelect: (warehouse: Warehouse | null) => void;
  error?: string;
  isLoading?: boolean;
  isLocation?: boolean;
  showHeaders?: boolean;
}

export const DeliveryLocation: React.FC<DeliveryLocationProps> = ({
  warehouses,
  value,
  onSelect,
  error,
  isLoading,
  isLocation,
  showHeaders = false,
}) => {
  const selectedValue = value ? value.id?.toString() : "";

  return (
    <div className="w-full bg-white">
      {/** Column headers */}
      {showHeaders && (
        <div className="grid grid-cols-3 items-center gap-4 text-sm font-medium text-gray-800 mb-1">
          <span className="truncate">Farm Collection Center Name</span>
          <span className="truncate">Location</span>
          <span className="truncate">Farm Collection Center Capacity</span>
        </div>
      )}
      {/** Dropdown */}
      <Select
        isLocation={isLocation}
        customSelectStyle="block"
        value={selectedValue}
        onValueChange={(val: string) => {
          const selectedWarehouse =
            warehouses.find((w) => w.id.toString() === val) || null;
          onSelect(selectedWarehouse);
        }}
        placeholder="Select Farm Collection Center"
        disabled={isLoading}
        options={warehouses.map((w) => ({
          value: w.id.toString(),
          label: (
            <div className="grid grid-cols-3 gap-5 py-2 w-full">
              <span className="text-gray-900 font-normal truncate text-left">
                {w.centerName}
              </span>
              <span className="text-gray-600 text-sm truncate text-left">
                {w.location}
              </span>
              <span className="text-gray-900 text-sm pl-4 text-left">
                {w.capacity}
              </span>
            </div>
          ),
        }))}
        className="w-full delivery-location-select"
      />

      {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
    </div>
  );
};
